import { values } from 'lodash';
import { appQueryParameters } from '@clubmed/utils';
export const AUTHORIZED_QUERY_PARAMS = [
  appQueryParameters.bypassCache,
  appQueryParameters.hash,
  appQueryParameters.locale,
  appQueryParameters.state,
  appQueryParameters.cms.commonRelease,
  appQueryParameters.cms.commonContent,
  appQueryParameters.cms.pagesRelease,
  appQueryParameters.cms.pagesContent,
  appQueryParameters.legacy.pays,
  appQueryParameters.legacy.lang,
  appQueryParameters.legacy.be,
  appQueryParameters.visitorGUID,
  appQueryParameters.cxo.cxo_sales_network_id,
  appQueryParameters.cxo.cxo_opportunity_guid,
  appQueryParameters.cxo.cxo_url,
  appQueryParameters.cxo.cxo_traveler,
  appQueryParameters.cxo.cxo_primarycontact,
  appQueryParameters.cxo.init_na,
  appQueryParameters.cxo.salesman_code,
  appQueryParameters.cxo.cxo_village,
  appQueryParameters.cxo.cxo_azur_code,
  appQueryParameters.cxo.cxo_user_id,
  appQueryParameters.cxo.cxo_sales_channel,
  appQueryParameters.cxo.cxo_country_code,
  appQueryParameters.cxo.cxo_id,
  appQueryParameters.cxo.cxo_neolid,
  appQueryParameters.cxo.call_reference,
  appQueryParameters.cxo.contact_id,
  appQueryParameters.forceAuth,
  appQueryParameters.indirect,
  appQueryParameters.cmta.cm_ta,
  appQueryParameters.productId,
  appQueryParameters.hasSaveOption,
  appQueryParameters.productsComparison.productIds,
  appQueryParameters.booking.proposalId,
  appQueryParameters.booking.proposalIds,
  appQueryParameters.booking.selectedProposalId,
  appQueryParameters.booking.bookingId,
  appQueryParameters.booking.coderesort,
  appQueryParameters.booking.fromSearches,
  appQueryParameters.booking.isFromSeller,
  appQueryParameters.booking.voxpay,
  appQueryParameters.booking.refresh,
  appQueryParameters.openLayer,
  appQueryParameters.openLayerState,
  appQueryParameters.shopping.offer,
  appQueryParameters.futureTravelCreditOption,
  appQueryParameters.disableLayout,
  appQueryParameters.component,
  appQueryParameters.noThirdParty,
  appQueryParameters.catId,
  appQueryParameters.isGsa,
  appQueryParameters.redirectUri,
  ...values(appQueryParameters.ignore),
];
export const HASH_PARAMS_DELIMITER = '#?';
export const QUERY_DEPARTURE_DATE = appQueryParameters.ignore.date;
export const QUERY_DATE_FORMAT = 'YYYY-MM-DD';
export const QUERY_DURATION = appQueryParameters.ignore.duration;
export const QUERY_TRANSPORT = appQueryParameters.ignore.departure_city;
export const QUERY_KIDS = 'kids';
export const QUERY_KIDS_DELIMITER = '_';
export const QUERY_FACET_OPTIONS_DELIMITER = '__';
export const QUERY_CHILDCARE_FLAG = 'c';
export const QUERY_NUMBER_OF_ADULTS = appQueryParameters.ignore.number_of_adults;
export const QUERY_FETCH_PROPOSALS = appQueryParameters.ignore.fetch;
export const QUERY_CMTA = appQueryParameters.cmta.cm_ta;
export const QUERY_CXO_SALES_NETWORK_ID = appQueryParameters.cxo.cxo_sales_network_id;
